// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9700) return "static/chunks/9700-8542fc729f4f5f04.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "301a22c41ba8a57a" + ".js";
};